import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { auth } from '../../../config/Fire';
import { setLogout } from '../../../actions/user';
import { getUser, getCompanies } from '../../../reducers';
import * as Constants from '../../../constants';
import LoadingPage from '../../components/LoadingPage';
import MainMenuClient from '../../components/MainMenuClient';
import ChatClient from '../ChatClient';
import ChatHistoricalClient from '../ChatHistoricalClient';
import InventoryHistorical from '../InventoryHistorical';
import WarningDimensions from '../../components/WarningDimensions';
import { getAllCompanies } from '../../../actions/company/getAllCompanies';

const { Content, Footer } = Layout;

class MainClient extends Component {
    state = {
        itemSelected: Constants.MenuClient.CHAT
    }

    onItemClick = ({itemClickType}) => {
        switch (itemClickType) {
            case Constants.MenuClient.CHAT:
                this.props.history.push(`/`);
                break;
            case Constants.MenuClient.LOGOUT:
                this.props.setLogout();
                auth.signOut();
                this.props.history.push(`/`);
                break;
            default:
                this.props.history.push(`/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    handlerGetInfo = () => {
        this.props.getAllCompanies();
        return <LoadingPage />
    }

    render() {
        const { location, companies, user } = this.props;
        return (
            <div>
                {
                    companies ?
                        <Layout>
                            <MainMenuClient onItemClick={this.onItemClick} itemSelected={location.pathname} user={user}/>
                            {
                                window.innerWidth >= 768 ?
                                    <Content>
                                        {
                                            Constants.UsersWithPermissions.includes(user.email) &&
                                                <span>
                                                    <Route  exact path={`/${Constants.MenuClient.INVENTORY_HISTORICAL}`} component={ InventoryHistorical } />
                                                </span>
                                        }
                                        <Route  exact path={`/${Constants.MenuClient.HISTORICAL_CHAT}`} component={ ChatHistoricalClient } />
                                        <Route  exact path="/" component={ ChatClient } />
                                    </Content>
                                    :
                                    <Content>
                                        <WarningDimensions />
                                    </Content>
                            }
                            <Footer style={{ textAlign: 'center', padding: "8px 50px" }}>
                                Copyright - Sitio desarrollado por <a href="https://www.autosolve.com.ar/" target="_blank" rel="noopener noreferrer">AutoSolve</a> | Todos los derechos reservados ©2020
                            </Footer>
                        </Layout>
                        :
                        this.handlerGetInfo()
                }
            </div>
        );
    }
}

MainClient.propTypes = {
    setLogout: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setLogout: value => dispatch(setLogout(value)),
    getAllCompanies: value => dispatch(getAllCompanies(value)),
});

const mapStateToProps = state => ({
    user:  getUser(state),
    companies:  getCompanies(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(MainClient));
